import { render, staticRenderFns } from "./Screen.vue?vue&type=template&id=3a7d89c7&scoped=true&"
import script from "./Screen.vue?vue&type=script&lang=js&"
export * from "./Screen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7d89c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a7d89c7')) {
      api.createRecord('3a7d89c7', component.options)
    } else {
      api.reload('3a7d89c7', component.options)
    }
    module.hot.accept("./Screen.vue?vue&type=template&id=3a7d89c7&scoped=true&", function () {
      api.rerender('3a7d89c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/screen/Screen.vue"
export default component.exports